export default "__VITE_ASSET__Dm2XyH4C__"